export class CartGift extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.propertyKey = '__gift_packaging'
    this.activeClass = 'gft-Accordion_Item-active'

    this.setButtonText()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.accordion.element,
      'toggle',
      this.handleAccordionToggle.bind(this),
    )

    this.listeners.add(this, 'click', this.handleItemClick.bind(this))
  }

  handleAccordionToggle (e) {
    const buttonEl = this.els.button.element

    if (e.target.hasAttribute('open')) {
      buttonEl.innerHTML = buttonEl.getAttribute('data-close')
      return
    }

    this.setButtonText()
  }

  handleItemClick (e) {
    if (!e.target.closest(this.els.item.selector)) return

    const buttonEl = this.els.button.element
    const itemEl = e.target.closest(this.els.item.selector)
    const itemId = itemEl.getAttribute('data-variant-id')

    if (!itemEl.getAttribute('data-active')) {
      const itemToAdd = {
        id: itemId,
        quantity: 1,
        properties: {
          [this.propertyKey]: `true`,
        },
      }

      window.BAO.Cart.addItem(itemToAdd)
      itemEl.classList.add(this.activeClass)
      buttonEl.setAttribute('data-use-text', 'edit')
    } else {
      window.BAO.Cart.removeItem(itemEl.getAttribute('data-active'))
      itemEl.classList.remove(this.activeClass)
      buttonEl.setAttribute('data-use-text', 'add')
    }
  }

  setButtonText () {
    const buttonEl = this.els.button.element
    switch (buttonEl.getAttribute('data-use-text')) {
      case 'add':
        buttonEl.innerHTML = buttonEl.getAttribute('data-add')
        break
      case 'edit':
        buttonEl.innerHTML = buttonEl.getAttribute('data-edit')
        break
    }
  }
}

if (!customElements.get('cart-gift')) {
  customElements.define('cart-gift', CartGift)
}
